import React from 'react';
import {Select} from 'antd';
import moment from "moment";
import * as math from 'mathjs';

const Option = Select.Option;

export default {
    /**
     * 获取某天，前一月第一天、后一月最后一天（日历用）
     * @param date
     * @returns {{firstDay: string, lastDay: string}}
     */
    getDateRangeDay(date) {
        const newDate_1 = new Date(new Date().setMonth(date.getMonth() - 1))
        var month_1 = newDate_1.getMonth() + 1
        var year_1 = newDate_1.getFullYear()
        if (month_1 === 0) {
            month_1 = 12
            year_1 = year_1 - 1
        }
        if (month_1 < 10) {
            month_1 = '0' + month_1
        }
        var firstDay = year_1 + '-' + month_1 + '-01'

        const newDate_2 = new Date(new Date().setMonth(date.getMonth() + 1))
        var month_2 = newDate_2.getMonth() + 1
        var year_2 = newDate_2.getFullYear()
        if (month_2 === 0) {
            month_2 = 12
            year_2 = year_2 - 1
        }
        if (month_2 < 10) {
            month_2 = '0' + month_2
        }
        var myDate = new Date(year_2, month_2, 0)
        var lastDay = year_2 + '-' + month_2 + '-' + myDate.getDate()
        return {firstDay: firstDay, lastDay: lastDay}
    },
    formateDate(time, fmt) {
        if (!time) return '';
        let date = new Date(time);
        let Y = date.getFullYear() + '-';
        let M =
            (date.getMonth() + 1 < 10
                ? '0' + (date.getMonth() + 1)
                : date.getMonth() + 1) + '-';
        let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        let h =
            date.getHours() < 10
                ? '0' + date.getHours() + ':'
                : date.getHours() + ':';
        let m =
            date.getMinutes() < 10
                ? '0' + date.getMinutes() + ':'
                : date.getMinutes() + ':';
        let s =
            date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        if (fmt === 'YYYY-MM-DD hh:mm:ss') {
            return Y + M + D + ' ' + h + m + s;
        } else if (fmt === 'YYYY-MM-DD hh:mm') {
            let m =
                date.getMinutes() < 10
                    ? '0' + date.getMinutes()
                    : date.getMinutes();
            return Y + M + D + ' ' + h + m;
        } else if (fmt === 'YYYY-MM-DD') {
            return Y + M + D;
        } else if (fmt === 'YYYY-MM') {
            M =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1);
            return Y + M;
        } else if (fmt === 'MM-dd') {
            return M + D;
        } else if (fmt === 'YYYY-MM-DD 23:59:59') {
            return Y + M + D + ' 23:59:59';
        } else if (fmt === 'hh:mm:ss') {
            return h + m + s;
        } else if (fmt === 'hh:mm') {
            m =
                date.getMinutes() < 10
                    ? '0' + date.getMinutes()
                    : date.getMinutes();
            return h + m
        } else if (fmt === 'YYYY-MM-DD 00:00:00') {
            return Y + M + D + ' 00:00:00';
        } else if (fmt === 'YYYYMMDD') {
            let Y = date.getFullYear() + ''
            let M =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '';
            let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            return Y + M + D;
        }
        return Y + M + D;
    },
    toHourMinute(minutes) {
        if (minutes) return (Math.floor(minutes / 60) + "小时" + (minutes % 60) + "分");
    },
    getComdify(num) {
        // if (s !== null && s !== '' && s !== undefined) {
        //     var n = 2
        //     n = n > 0 && n <= 20 ? n : 2
        //     s = parseFloat((s + '').replace(/[^\d-]/g, '')).toFixed(n) + ''
        //     var l = s.split('.')[0].split('').reverse()
        //     var r = s.split('.')[1]
        //     var t = ''
        //     for (var i = 0; i < l.length; i++) {
        //         t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
        //     }
        //     return t.split('').reverse().join('') + '.' + r
        // } else {
        //     return ''
        // }
        if (num) {
            num = num.toFixed(2);
            num = parseFloat(num);
            num = num.toLocaleString();
            // 数字为整数时  100 => 100.00
            if (num.indexOf('.') < 0) {
                num += '.00';
            }
            // 数字只有一位小数时 100.3 => 100.30
            if (num.split('.')[1].length === 1) {
                num += '0';
            }
        }

        return num;
    },
    toMoney(num) {
        if (num) {
            num = num.toFixed(2);
            num = parseFloat(num);
            num = num.toLocaleString();
            // 数字为整数时  100 => 100.00
            if (num.indexOf('.') < 0) {
                num += '.00';
            }
            // 数字只有一位小数时 100.3 => 100.30
            if (num.split('.')[1].length === 1) {
                num += '0';
            }
        }

        return num;
    },
    getCountType(s) {
        if (s !== null && s !== '' && s !== undefined) {
            var n = 2
            n = n > 0 && n <= 20 ? n : 2
            s = parseFloat((s + '').replace(/[^\d-]/g, '')).toFixed(n) + ''
            var l = s.split('.')[0].split('').reverse()
            var t = ''
            for (var i = 0; i < l.length; i++) {
                t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
            }
            return t.split('').reverse().join('')
        } else {
            return ''
        }
    },
    pagination(data, callback) {
        return {
            onChange: current => {
                callback(current);
            },
            current: data.result.page,
            pageSize: data.result.page_size,
            total: data.result.total_count,
            showTotal: () => {
                return `共${data.result.total_count}条`;
            },
            showQuickJumper: true
        };
    },
    getOptionList(data) {
        if (!data) {
            return [];
        } else {
            let options = [];
            data.forEach(item => {
                options.push(
                    <Option value={item.code} key={item.id}>
                        {item.value}
                    </Option>
                );
            });
            return options;
        }
    },
    updateSelectedItem(selectedRowKeys, selectedItem, selectedIds) {
        //封装Table 点击当前行 把当前行 key存起来，显示选中
        if (selectedIds) {
            //多选
            this.setState({
                selectedRowKeys,
                selectedItem,
                selectedIds
            });
        } else {
            this.setState({
                selectedRowKeys,
                selectedItem
            });
        }
    },
    changeTwoDecimal_f(val, len) {
        if (val === 0) return 0
        var f = parseFloat(val);
        if (isNaN(f)) {
            return false;
        }
        f = Math.round(val * Math.pow(10, len)) / Math.pow(10, len);
        var s = f.toString();
        var rs = s.indexOf('.');
        if (rs < 0) {
            if (len === 0) {
                s += '';
            } else {
                rs = s.length;
                s += '.';
            }
        }
        while (s.length <= rs + len) {
            s += '0';
        }
        return s;
    },

    /**
     * 按照seq排序
     * @param a
     * @param b
     * @returns {number}
     */
    sortSeq(a, b) {
        return a.seq - b.seq
    },
    /**
     * 获取起止日期内的 日期集合
     * @param start
     * @param end
     * @returns {[]}
     */
    getDateBetween(start, end) {
        var result = [];
        //使用传入参数的时间
        var startTime = new Date(start);
        var endTime = new Date(end);
        while (endTime - startTime >= 0) {
            let year = startTime.getFullYear();
            let month = startTime.getMonth();
            month = month < 9 ? '0' + (month + 1) : month + 1;
            let day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
            //加入数组
            result.push(year + "-" + month + "-" + day);
            //更新日期
            startTime.setDate(startTime.getDate() + 1);
        }
        return result;
    },
    /**
     * 判断字符串是否为 日期字符串
     * @param string
     */
    isDateString(string) {
        return isNaN(string) && !isNaN(Date.parse(string))
    },
    /**
     * 判断数据是否为 moment
     * @param value
     */
    isMoment(value) {
        return (typeof value) === 'object' && value._isAMomentObject
    },
    // 判断是不是数字
    isNumber(value) {
        return !isNaN(Number(value));
    },
    genID(length) {
        return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
    },
    isJson(str) {
        if (typeof str == 'string') {
            try {
                let obj = JSON.parse(str);
                if (typeof obj == 'object' && obj) {
                    return true;
                } else {
                    return false;
                }

            } catch (e) {
                return false;
            }
        }
    },
    getRanges() {
        return {
            上周: [moment().week(moment().week() - 1).startOf('week'), moment().week(moment().week() - 1).endOf('week')],
            '本周': [moment().startOf('week'), moment().endOf('week')],
            '上个月': [moment().month(moment().month() - 1).startOf('month'), moment().month(moment().month() - 1).endOf('month')],
            '这个月': [moment().startOf('month'), moment().endOf('month')],
        }
    },
    UCaseNumber(n) {
        let prefix = ''
        if (n < 0) {
            n = -n
            prefix = '负'
        }
        if (n === 0) return '零元整'
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return false
        var unit = "仟佰拾亿仟佰拾万仟佰拾元角分", str = "";
        n += "00";
        var p = n.indexOf('.');
        if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i = 0; i < n.length; i++) str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
        return prefix + str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
    },
    // 高精度加
    mathAdd(num1, num2) {
        if (num1 === '-' || num2 === '-') return 0
        return Number(math.add(math.bignumber(num1 || 0), math.bignumber(num2 || 0)));
    },
    // 高精度乘
    mathMultiply(num1, num2) {
        if (num1 === '-' || num2 === '-') return 0
        return Number(math.multiply(math.bignumber(num1 || 0), math.bignumber(num2 || 0)));
    },
    // 高精度减
    mathSubtract(num1, num2) {
        if (num1 === '-' || num2 === '-') return 0
        return Number(math.subtract(math.bignumber(num1 || 0), math.bignumber(num2 || 0)));
    },
    // 高精度除
    mathDivide(num1, num2) {
        if (num1 === '-' || num2 === '-') return 0
        return Number(math.divide(math.bignumber(num1 || 0), math.bignumber(num2 || 0)));
    },
    /**
     * 数字千位分隔符且保留两位小数
     * @param num
     * @returns {string|*}
     */
    thousandAndDecimal(value, decimalPlaces = 2) {
        if (value) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            }).format(value);
        } else if (value === 0) {
            return 0
        } else {
            return ''
        }
        // if (value) {
        //     var f = Math.round(value * Math.pow(10, n)) / Math.pow(10, n);
        //     var s = f.toString();
        //     var rs = s.indexOf('.');
        //     if (rs < 0) {
        //         s += '.';
        //     }
        //     for (var i = s.length - s.indexOf('.'); i <= n; i++) {
        //         s += "0";
        //     }
        //     return s;
        // }
    },
    /**
     * 数字千位分隔符且保留 小数位数
     * @param num
     * @returns {string|*}
     */

    formatNumberDecimalPlaces(num, decimalPlaces) {
        if (num) {
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            }).format(num);
        } else if (num === 0) {
            return 0
        } else {
            return ''
        }

    },
    // thousandAndDecimal(num,digit=2) {
    //     if(num) {
    //         return Number(num).toFixed(digit).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    //         // return (Math.floor(num * 100) / 100)
    //     } else {
    //         return '0.00'
    //     }
    // },
    disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().startOf('day');
    },
    getUrlParam(url) {
        var theParam = {};
        if (url.indexOf("?") !== -1) { //确保‘？’不是最后一个字符串，即携带的参数不为空
            var str = url.substr(1); //substr是字符串的用法之一，抽取指定字符的数目，这里抽取？后的所有字符
            let strs = str.split("&"); //将获取到的字符串从&分割，输出参数数组，即输出[参数1=xx,参数2=xx,参数3=xx,...]的数组形式
            for (var i = 0; i < strs.length; i++) { //遍历参数数组
                theParam[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]); //这里意思是抽取每个参数等号后面的值，unescape是解码的意思
            }
        }
        return theParam; //返回参数值
    },
    /**
     * 实时计算每行的科目余额
     * item 凭证行
     */
    getBalance(item, index, list) {
        let balance
        let debtor = Number(item.debtor)
        let lender = Number(item.lender)
        if (item.subject && item.subject.balanceDirection) {
            balance = item.subject.balance
            if (item.subject.balanceDirection.name === '借') {
                balance = this.mathAdd(balance, debtor)
                balance = this.mathSubtract(balance, lender)
                list.forEach((listItem, listIndex) => { // 当凭证详情有相同科目时
                    if (index > listIndex && list[listIndex].subject && item.subject.id === list[listIndex].subject.id) {
                        balance = this.mathAdd(balance, list[listIndex].debtor)
                        balance = this.mathSubtract(balance, list[listIndex].lender)
                        if (list[listIndex].oldSubject && list[listIndex].oldSubject.id === list[listIndex].subject.id) { // 更新凭证时
                            balance = this.mathSubtract(balance, Number(list[listIndex].oldSubject.debtor))
                            balance = this.mathAdd(balance, Number(list[listIndex].oldSubject.lender))
                        }
                    }
                })
                if (item.oldSubject && item.oldSubject.id === item.subject.id) { // 更新凭证时
                    balance = this.mathSubtract(balance, Number(item.oldSubject.debtor))
                    balance = this.mathAdd(balance, Number(item.oldSubject.lender))
                }
            } else if (item.subject.balanceDirection.name === '贷') {
                balance = this.mathSubtract(balance, debtor)
                balance = this.mathAdd(balance, lender)
                list.forEach((listItem, listIndex) => { // 当凭证详情有相同科目时
                    if (index > listIndex && list[listIndex].subject && item.subject.id === list[listIndex].subject.id) {
                        balance = this.mathSubtract(balance, list[listIndex].debtor)
                        balance = this.mathAdd(balance, list[listIndex].lender)
                        if (list[listIndex].oldSubject && list[listIndex].oldSubject.id === list[listIndex].subject.id) { // 更新凭证时
                            balance = this.mathAdd(balance, Number(list[listIndex].oldSubject.debtor))
                            balance = this.mathSubtract(balance, Number(list[listIndex].oldSubject.lender))
                        }
                    }
                })
                if (item.oldSubject && item.oldSubject.id === item.subject.id) { // 更新凭证时
                    balance = this.mathAdd(balance, Number(item.oldSubject.debtor))
                    balance = this.mathSubtract(balance, Number(item.oldSubject.lender))
                }
            }
        }
        return balance && balance !== 0 ? balance.toFixed(2) : ''
    },
    /**
     * 解析字符串中{}中间的字符
     * @param str
     * @returns {*|*[]}
     */
    extractTextWithinBraces(str) {
        if (!str) return []
        // 正则表达式匹配花括号内的内容
        const regex = /{([^}]+)}/g;
        // 使用match方法获取所有匹配的结果
        const matches = str.match(regex);
        // 提取并返回不含花括号的结果
        return matches ? matches.map(match => match.substring(1, match.length - 1)) : [];
    },

    /**
     * 从 localStorage 获取指定 key 的数据
     * @param {string} key - 要获取的数据的键名
     * @returns {object|null} 如果找到数据则返回解析后的对象，否则返回 null
     */
    getLocalStorageByKey(key) {
        try {
            const item = localStorage.getItem(key);
            if (item === null) {
                return null;
            }
            return JSON.parse(item);
        } catch (error) {
            console.error(`从 localStorage 获取键为 "${key}" 的数据时出错:`, error);
            return null;
        }
    },

    /**
     * 将数据保存到 localStorage
     * @param {string} key - 要存储的数据的键名
     * @param {object} objectData - 要存储的对象数据
     * @returns {boolean} 保存成功返回 true，失败返回 false
     */
    setLocalStorageByKey(key, objectData) {
        try {
            localStorage.setItem(key, JSON.stringify(objectData));
            return true;
        } catch (error) {
            console.error(`保存数据到 localStorage 键为 "${key}" 时出错:`, error);
            return false;
        }
    },
    /**
     * 在树（森林）中根据 id 查找节点所在的根节点
     * @param {Array} tree - 树形数据（森林）
     * @param {string|number} targetId - 要查找的节点 ID
     * @returns {Object|null} - 根节点对象，如果没找到返回 null
     */
    findRootNodeById(tree, targetId) {
        for (const root of tree) {
            // 如果当前根节点就是目标，则直接返回它自己（最上层就是它本身）
            if (root.key === targetId) return root;

            // 在子树中查找
            const found = this.findNodeInTree(root, targetId);
            if (found) return root; // 找到了，返回当前根节点
        }
        return null;
    },
    /**
     * 在单棵树（节点）中递归查找目标节点
     */
    findNodeInTree(node, targetId) {
        if (node.key === targetId) return node;
        if (node.children) {
            for (const child of node.children) {
                const found = this.findNodeInTree(child, targetId);
                if (found) return found;
            }
        }
        return null;
    }

};
